// DS: DS4.6
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import IconWrap from '../IconWrap';
const ThemeSwitchGreen = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, _object_spread({
        disableDefaultColors: true
    }, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, /*#__PURE__*/ React.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27Z",
        fill: "#D2DECC"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 22H10.75C10.3358 22 10 21.6642 10 21.25C10 20.7867 10.2499 20.3594 10.6537 20.1323L12 19.375V19C12 16.7909 13.7909 15 16 15H18V12C18 10.8954 18.8954 10 20 10H20.5C21.3284 10 22 10.6716 22 11.5C22 12.1528 21.5829 12.7083 21.0007 12.9144L21 16C21 17.3059 20.1656 18.4169 19.0009 18.829L19 22H17V20H16V22H14V20L13.9945 20.1493C13.9182 21.1841 13.0544 22 12 22Z",
        fill: "#617362"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M27.5 16C27.5 22.3513 22.3513 27.5 16 27.5C9.64873 27.5 4.5 22.3513 4.5 16C4.5 9.64872 9.64872 4.5 16 4.5C22.3513 4.5 27.5 9.64872 27.5 16Z",
        stroke: "#A8B2A7"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: "16",
        cy: "16",
        r: "14",
        stroke: "transparent",
        strokeWidth: "2"
    }))));
};
ThemeSwitchGreen.displayName = 'ThemeSwitchGreen';
export default ThemeSwitchGreen;

//# sourceMappingURL=ThemeSwitchGreen.js.map